export function getCronModel(cronFormatter, cron) {
  return cron ?
    cronFormatter.parse(cron) :
    { frequency: cronFormatter.getCronFrequenciesEnum().NONE };
}
